export enum MapPosition {
  TOP = 'MU_MAP_TOP',
}
